<div class="row">
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div class="card">
      <div class="materialTableHeader">
        <div class="left">
          <ul class="header-buttons-left ms-0">
            <li class="tbl-title">
              <h2 style="color: white">MIS RECETAS</h2>
            </li>
            <li class="tbl-search-box">
              <label><i class="material-icons search-icon">search</i></label>
              <input
                #filter
                aria-autocomplete="none"
                aria-label="Search box" autocomplete="nope" class="browser-default search-field"
                placeholder="BUSCAR"
                type="text">
            </li>
          </ul>
        </div>
        <div class="right">
          <ul class="tbl-export-btn">
            <li class="tbl-header-btn">
              <div class="m-l-10" matTooltip="RECARGAR">
                <button (click)="refresh()" color="primary" mat-mini-fab>
                  <mat-icon>refresh</mat-icon>
                </button>
              </div>
            </li>
            <li>
              <div class="export-button m-l-10" matTooltip="EXCEL">
                <img (click)="exportExcel()" alt="" height="512" ngSrc="assets/images/icons/xlsx.png" width="512"/>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="body overflow-auto">
        <div class="responsive_table">
          <table [dataSource]="dataSource" class="mat-cell advance-table" mat-table matSort>

            <ng-container matColumnDef="folio">
              <mat-header-cell *matHeaderCellDef mat-sort-header>FOLIO DE LA RECETA</mat-header-cell>
              <mat-cell *matCellDef="let row" matTooltip="{{row.folio}}"><span class="mobile-label">FOLIO:</span>
                <div class="block">
                  <span class="prop_four">{{ row.folio ? row.folio : 'SIN FOLIO' }}</span>
                </div>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="medico">
              <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header> MEDICO</mat-header-cell>
              <mat-cell *matCellDef="let row" matTooltip="{{row.nombreMedico}}"><span
                class="mobile-label">Medico: </span>
                <div class="block">
                      <span class="prop_three">
                            {{ row.nombreMedico }}
                      </span>
                  <span class="prop_two">CED. {{ row.cedulaGeneral }}</span>
                  <span
                    class="prop_two">ESPECIALIDAD: {{ row.especialidad ? row.especialidad : 'Sin especialidad' }}</span>
                </div>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="gemp">
              <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header> GRUPO Y SUCURSAL</mat-header-cell>
              <mat-cell *matCellDef="let row" matTooltip="{{row.grupoEmpresarial}}"><span
                class="mobile-label">Grupo y Sucursal: </span>
                <div class="block">
                      <span class="prop_one">
                            {{ row.grupoEmpresarial }}
                      </span>
                  <span class="prop_two">{{ row.sucursal }}</span>

                </div>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="creacion">
              <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header> FECHA DE CREACION
              </mat-header-cell>
              <mat-cell *matCellDef="let row" matTooltip="{{row.fechaCreacion}}"><span
                class="mobile-label">Fecha de Creacion: </span>
                <div class="block">
                  <span class="prop_two">{{ row.fechaCreacion }}</span>
                </div>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef class="pr-0"> ESTATUS</mat-header-cell>
              <mat-cell *matCellDef="let row; let i = index;" class="pr-0">
                <span class="mobile-label">STATUS:</span>
                @if (row.descripcion === 'Activa') {
                  <span class="badge badge-solid-orange">
                        {{ row.descripcion }}</span>
                }
                @if (row.descripcion === 'Surtida') {
                  <span class="badge badge-solid-green">
                        {{ row.descripcion }}</span>
                }
                @if (row.descripcion === 'Cancelada') {
                  <span class="badge badge-solid-red">
                        {{ row.descripcion }}</span>
                }
                @if (row.descripcion === 'Vencida') {
                  <span class="badge badge-solid-brown">
                        {{ row.descripcion }}</span>
                }
                @if (row.descripcion === 'Surtida Parcialmente') {
                  <span class="badge badge-solid-blue">
                        {{ row.descripcion }}</span>
                }
                @if (row.descripcion === 'Vencida Surtida Parcialmente') {
                  <span class="badge badge-solid-purple">
                        {{ row.descripcion }}</span>
                }
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="detalles">
              <mat-header-cell *matHeaderCellDef class="headerCell" mat-sort-header>DETALLES</mat-header-cell>
              <mat-cell *matCellDef="let row; let i = index;" class="pr-0">
                <span class="mobile-label">DETALLES:</span>
                <button
                  (click)="$event.stopPropagation(); goToDetails(row)"
                  class="tbl-fav-std"
                  mat-icon-button>
                  <app-feather-icons [icon]="'layers'"></app-feather-icons>
                </button>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="descargar">
              <mat-header-cell *matHeaderCellDef class="pr-0"> DESCARGAR RECETA</mat-header-cell>
              <mat-cell *matCellDef="let row; let i = index;" class="pr-0">
                <span class="mobile-label">Descargar Receta:</span>
                <button
                  (click)="$event.stopPropagation(); descargarPDF(row)"
                  class="tbl-fav-std"
                  mat-icon-button>
                  <app-feather-icons [icon]="'download'"></app-feather-icons>
                </button>
                <button
                  (click)="$event.stopPropagation(); enviarRecetaPorCorreo(row)"
                  class="tbl-fav-std"
                  mat-icon-button
                  matTooltip="Enviar receta por correo">
                  <mat-icon color="primary">mail</mat-icon>
                </button>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
            </mat-row>
          </table>
          @if (data?.isTblLoading) {
            <div class="tbl-spinner">
              <mat-progress-spinner color="primary" [diameter]="40" mode="indeterminate">
              </mat-progress-spinner>
            </div>
          }
          @if (!data?.isTblLoading) {
            <div class="no-results" [style.display]="dataSource.renderedData.length === 0 ? '' : 'none'">
              SIN RESULTADOS
            </div>
          }
          <mat-paginator [length]="dataSource.filteredData.length" [pageIndex]="0"
                         [pageSizeOptions]="[5, 10, 25, 100]"
                         [pageSize]="10">
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
